<template>
  <div class="lg:px-24">
    <Carousel
      class="w-full"
      :opts="{
        align: 'center',
        loop: false,
      }"
    >
      <CarouselContent>
        <CarouselItem
          v-for="(card, index) in cards"
          :key="index"
          :class="getCarouselItemClass(index, cards.length)"
          class="h-auto"
        >
          <div class="p-1 h-full">
            <Card class="p-0 border-0 shadow-none bg-grey-light-50 h-full">
              <CardContent class="flex flex-col p-7 h-full">
                <div :class="iconBgClass" class="p-3 rounded-lg w-max">
                  <component :is="getIconComponent(card.icon)" :class="iconTextClass" :size="iconSize" />
                </div>
                <h3 :class="titleClass" class="mt-6 mb-4">{{ card.title }}</h3>
                <p :class="descriptionClass" class="text-gray-600" v-html="card.description"></p>
              </CardContent>
            </Card>
          </div>
        </CarouselItem>
      </CarouselContent>
      <CarouselDotButtons class="mt-4 lg:hidden" selected-class="border-primary" />
    </Carousel>
  </div>
</template>

<script setup lang="ts">
import { Card, CardContent } from '@/components/ui/card';
import { Carousel, CarouselContent, CarouselDotButtons, CarouselItem } from '@/components/ui/carousel';
import { getIconComponent } from '@/utils/icons';
import { getCarouselItemClass } from '@/utils/slider';

export interface InfoCard {
  icon: string;
  title: string;
  description: string;
}

interface Props {
  cards: InfoCard[];
  iconSize?: number;
  iconBgClass?: string;
  iconTextClass?: string;
  titleClass?: string;
  descriptionClass?: string;
}

withDefaults(defineProps<Props>(), {
  iconSize: 24,
  iconBgClass: 'bg-primary',
  iconTextClass: 'text-white',
  titleClass: 'text-2xl font-semibold',
  descriptionClass: 'text-lg md:text-xl',
});
</script>
